import * as React from 'react';
import {ITextProps} from './ITextProps';
import {Base} from './Base';

export const Tt3 = (props: ITextProps) => {
  return <Base typoClass="typo3" {...props} />;
};
